/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  ActionRunResponse,
  BranchActionBody,
  BranchDeleteResponse,
  BranchDetailResponse,
  BranchResponse,
  BranchRestoreResponse,
  BranchUpdateResponse,
  CreateBranchBody,
  ListActionRunResponse,
  UpdateBranchBody,
  UpdateRunStatusBody,
  UpdateRunStatusResponse,
  V1DeleteABranchParams,
  V1DiffABranchParams,
  V1ListActionRunsParams
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * Fetches configurations of the specified database branch
 * @summary Get database branch config
 */
export type v1GetABranchConfigResponse200 = {
  data: BranchDetailResponse
  status: 200
}

export type v1GetABranchConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetABranchConfigResponseSuccess = (v1GetABranchConfigResponse200) & {
  headers: Headers;
};
export type v1GetABranchConfigResponseError = (v1GetABranchConfigResponse500) & {
  headers: Headers;
};

export type v1GetABranchConfigResponse = (v1GetABranchConfigResponseSuccess | v1GetABranchConfigResponseError)

export const getV1GetABranchConfigUrl = (branchIdOrRef: string,) => {


  

  return `/v1/branches/${branchIdOrRef}`
}

export const v1GetABranchConfig = async (branchIdOrRef: string, options?: RequestInit): Promise<v1GetABranchConfigResponse> => {
  
  return customFetch<v1GetABranchConfigResponse>(getV1GetABranchConfigUrl(branchIdOrRef),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Updates the configuration of the specified database branch
 * @summary Update database branch config
 */
export type v1UpdateABranchConfigResponse200 = {
  data: BranchResponse
  status: 200
}

export type v1UpdateABranchConfigResponse500 = {
  data: void
  status: 500
}

export type v1UpdateABranchConfigResponseSuccess = (v1UpdateABranchConfigResponse200) & {
  headers: Headers;
};
export type v1UpdateABranchConfigResponseError = (v1UpdateABranchConfigResponse500) & {
  headers: Headers;
};

export type v1UpdateABranchConfigResponse = (v1UpdateABranchConfigResponseSuccess | v1UpdateABranchConfigResponseError)

export const getV1UpdateABranchConfigUrl = (branchIdOrRef: string,) => {


  

  return `/v1/branches/${branchIdOrRef}`
}

export const v1UpdateABranchConfig = async (branchIdOrRef: string,
    updateBranchBody: UpdateBranchBody, options?: RequestInit): Promise<v1UpdateABranchConfigResponse> => {
  
  return customFetch<v1UpdateABranchConfigResponse>(getV1UpdateABranchConfigUrl(branchIdOrRef),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateBranchBody,)
  }
);}
  

/**
 * Deletes the specified database branch. By default, deletes immediately. Use force=false to schedule deletion with 1-hour grace period (only when soft deletion is enabled).
 * @summary Delete a database branch
 */
export type v1DeleteABranchResponse200 = {
  data: BranchDeleteResponse
  status: 200
}

export type v1DeleteABranchResponse500 = {
  data: void
  status: 500
}

export type v1DeleteABranchResponseSuccess = (v1DeleteABranchResponse200) & {
  headers: Headers;
};
export type v1DeleteABranchResponseError = (v1DeleteABranchResponse500) & {
  headers: Headers;
};

export type v1DeleteABranchResponse = (v1DeleteABranchResponseSuccess | v1DeleteABranchResponseError)

export const getV1DeleteABranchUrl = (branchIdOrRef: string,
    params?: V1DeleteABranchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/branches/${branchIdOrRef}?${stringifiedParams}` : `/v1/branches/${branchIdOrRef}`
}

export const v1DeleteABranch = async (branchIdOrRef: string,
    params?: V1DeleteABranchParams, options?: RequestInit): Promise<v1DeleteABranchResponse> => {
  
  return customFetch<v1DeleteABranchResponse>(getV1DeleteABranchUrl(branchIdOrRef,params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Pushes the specified database branch
 * @summary Pushes a database branch
 */
export type v1PushABranchResponse201 = {
  data: BranchUpdateResponse
  status: 201
}

export type v1PushABranchResponse500 = {
  data: void
  status: 500
}

export type v1PushABranchResponseSuccess = (v1PushABranchResponse201) & {
  headers: Headers;
};
export type v1PushABranchResponseError = (v1PushABranchResponse500) & {
  headers: Headers;
};

export type v1PushABranchResponse = (v1PushABranchResponseSuccess | v1PushABranchResponseError)

export const getV1PushABranchUrl = (branchIdOrRef: string,) => {


  

  return `/v1/branches/${branchIdOrRef}/push`
}

export const v1PushABranch = async (branchIdOrRef: string,
    branchActionBody: BranchActionBody, options?: RequestInit): Promise<v1PushABranchResponse> => {
  
  return customFetch<v1PushABranchResponse>(getV1PushABranchUrl(branchIdOrRef),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      branchActionBody,)
  }
);}
  

/**
 * Merges the specified database branch
 * @summary Merges a database branch
 */
export type v1MergeABranchResponse201 = {
  data: BranchUpdateResponse
  status: 201
}

export type v1MergeABranchResponse500 = {
  data: void
  status: 500
}

export type v1MergeABranchResponseSuccess = (v1MergeABranchResponse201) & {
  headers: Headers;
};
export type v1MergeABranchResponseError = (v1MergeABranchResponse500) & {
  headers: Headers;
};

export type v1MergeABranchResponse = (v1MergeABranchResponseSuccess | v1MergeABranchResponseError)

export const getV1MergeABranchUrl = (branchIdOrRef: string,) => {


  

  return `/v1/branches/${branchIdOrRef}/merge`
}

export const v1MergeABranch = async (branchIdOrRef: string,
    branchActionBody: BranchActionBody, options?: RequestInit): Promise<v1MergeABranchResponse> => {
  
  return customFetch<v1MergeABranchResponse>(getV1MergeABranchUrl(branchIdOrRef),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      branchActionBody,)
  }
);}
  

/**
 * Resets the specified database branch
 * @summary Resets a database branch
 */
export type v1ResetABranchResponse201 = {
  data: BranchUpdateResponse
  status: 201
}

export type v1ResetABranchResponse500 = {
  data: void
  status: 500
}

export type v1ResetABranchResponseSuccess = (v1ResetABranchResponse201) & {
  headers: Headers;
};
export type v1ResetABranchResponseError = (v1ResetABranchResponse500) & {
  headers: Headers;
};

export type v1ResetABranchResponse = (v1ResetABranchResponseSuccess | v1ResetABranchResponseError)

export const getV1ResetABranchUrl = (branchIdOrRef: string,) => {


  

  return `/v1/branches/${branchIdOrRef}/reset`
}

export const v1ResetABranch = async (branchIdOrRef: string,
    branchActionBody: BranchActionBody, options?: RequestInit): Promise<v1ResetABranchResponse> => {
  
  return customFetch<v1ResetABranchResponse>(getV1ResetABranchUrl(branchIdOrRef),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      branchActionBody,)
  }
);}
  

/**
 * Cancels scheduled deletion and restores the branch to active state
 * @summary Restore a scheduled branch deletion
 */
export type v1RestoreABranchResponse200 = {
  data: BranchRestoreResponse
  status: 200
}

export type v1RestoreABranchResponse500 = {
  data: void
  status: 500
}

export type v1RestoreABranchResponseSuccess = (v1RestoreABranchResponse200) & {
  headers: Headers;
};
export type v1RestoreABranchResponseError = (v1RestoreABranchResponse500) & {
  headers: Headers;
};

export type v1RestoreABranchResponse = (v1RestoreABranchResponseSuccess | v1RestoreABranchResponseError)

export const getV1RestoreABranchUrl = (branchIdOrRef: string,) => {


  

  return `/v1/branches/${branchIdOrRef}/restore`
}

export const v1RestoreABranch = async (branchIdOrRef: string, options?: RequestInit): Promise<v1RestoreABranchResponse> => {
  
  return customFetch<v1RestoreABranchResponse>(getV1RestoreABranchUrl(branchIdOrRef),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Diffs the specified database branch
 * @summary [Beta] Diffs a database branch
 */
export type v1DiffABranchResponse200 = {
  data: string
  status: 200
}

export type v1DiffABranchResponse500 = {
  data: void
  status: 500
}

export type v1DiffABranchResponseSuccess = (v1DiffABranchResponse200) & {
  headers: Headers;
};
export type v1DiffABranchResponseError = (v1DiffABranchResponse500) & {
  headers: Headers;
};

export type v1DiffABranchResponse = (v1DiffABranchResponseSuccess | v1DiffABranchResponseError)

export const getV1DiffABranchUrl = (branchIdOrRef: string,
    params?: V1DiffABranchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/branches/${branchIdOrRef}/diff?${stringifiedParams}` : `/v1/branches/${branchIdOrRef}/diff`
}

export const v1DiffABranch = async (branchIdOrRef: string,
    params?: V1DiffABranchParams, options?: RequestInit): Promise<v1DiffABranchResponse> => {
  
  return customFetch<v1DiffABranchResponse>(getV1DiffABranchUrl(branchIdOrRef,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Returns a paginated list of action runs of the specified project.
 * @summary List all action runs
 */
export type v1ListActionRunsResponse200 = {
  data: ListActionRunResponse
  status: 200
}

export type v1ListActionRunsResponse401 = {
  data: void
  status: 401
}

export type v1ListActionRunsResponse403 = {
  data: void
  status: 403
}

export type v1ListActionRunsResponse429 = {
  data: void
  status: 429
}

export type v1ListActionRunsResponse500 = {
  data: void
  status: 500
}

export type v1ListActionRunsResponseSuccess = (v1ListActionRunsResponse200) & {
  headers: Headers;
};
export type v1ListActionRunsResponseError = (v1ListActionRunsResponse401 | v1ListActionRunsResponse403 | v1ListActionRunsResponse429 | v1ListActionRunsResponse500) & {
  headers: Headers;
};

export type v1ListActionRunsResponse = (v1ListActionRunsResponseSuccess | v1ListActionRunsResponseError)

export const getV1ListActionRunsUrl = (ref: string,
    params?: V1ListActionRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/actions?${stringifiedParams}` : `/v1/projects/${ref}/actions`
}

export const v1ListActionRuns = async (ref: string,
    params?: V1ListActionRunsParams, options?: RequestInit): Promise<v1ListActionRunsResponse> => {
  
  return customFetch<v1ListActionRunsResponse>(getV1ListActionRunsUrl(ref,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Returns the total number of action runs of the specified project.
 * @summary Count the number of action runs
 */
export type v1CountActionRunsResponse200 = {
  data: void
  status: 200
}

export type v1CountActionRunsResponse401 = {
  data: void
  status: 401
}

export type v1CountActionRunsResponse403 = {
  data: void
  status: 403
}

export type v1CountActionRunsResponse429 = {
  data: void
  status: 429
}

export type v1CountActionRunsResponse500 = {
  data: void
  status: 500
}

export type v1CountActionRunsResponseSuccess = (v1CountActionRunsResponse200) & {
  headers: Headers;
};
export type v1CountActionRunsResponseError = (v1CountActionRunsResponse401 | v1CountActionRunsResponse403 | v1CountActionRunsResponse429 | v1CountActionRunsResponse500) & {
  headers: Headers;
};

export type v1CountActionRunsResponse = (v1CountActionRunsResponseSuccess | v1CountActionRunsResponseError)

export const getV1CountActionRunsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/actions`
}

export const v1CountActionRuns = async (ref: string, options?: RequestInit): Promise<v1CountActionRunsResponse> => {
  
  return customFetch<v1CountActionRunsResponse>(getV1CountActionRunsUrl(ref),
  {      
    ...options,
    method: 'HEAD'
    
    
  }
);}
  

/**
 * Returns the current status of the specified action run.
 * @summary Get the status of an action run
 */
export type v1GetActionRunResponse200 = {
  data: ActionRunResponse
  status: 200
}

export type v1GetActionRunResponse401 = {
  data: void
  status: 401
}

export type v1GetActionRunResponse403 = {
  data: void
  status: 403
}

export type v1GetActionRunResponse429 = {
  data: void
  status: 429
}

export type v1GetActionRunResponse500 = {
  data: void
  status: 500
}

export type v1GetActionRunResponseSuccess = (v1GetActionRunResponse200) & {
  headers: Headers;
};
export type v1GetActionRunResponseError = (v1GetActionRunResponse401 | v1GetActionRunResponse403 | v1GetActionRunResponse429 | v1GetActionRunResponse500) & {
  headers: Headers;
};

export type v1GetActionRunResponse = (v1GetActionRunResponseSuccess | v1GetActionRunResponseError)

export const getV1GetActionRunUrl = (ref: string,
    runId: string,) => {


  

  return `/v1/projects/${ref}/actions/${runId}`
}

export const v1GetActionRun = async (ref: string,
    runId: string, options?: RequestInit): Promise<v1GetActionRunResponse> => {
  
  return customFetch<v1GetActionRunResponse>(getV1GetActionRunUrl(ref,runId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Updates the status of an ongoing action run.
 * @summary Update the status of an action run
 */
export type v1UpdateActionRunStatusResponse200 = {
  data: UpdateRunStatusResponse
  status: 200
}

export type v1UpdateActionRunStatusResponse401 = {
  data: void
  status: 401
}

export type v1UpdateActionRunStatusResponse403 = {
  data: void
  status: 403
}

export type v1UpdateActionRunStatusResponse429 = {
  data: void
  status: 429
}

export type v1UpdateActionRunStatusResponse500 = {
  data: void
  status: 500
}

export type v1UpdateActionRunStatusResponseSuccess = (v1UpdateActionRunStatusResponse200) & {
  headers: Headers;
};
export type v1UpdateActionRunStatusResponseError = (v1UpdateActionRunStatusResponse401 | v1UpdateActionRunStatusResponse403 | v1UpdateActionRunStatusResponse429 | v1UpdateActionRunStatusResponse500) & {
  headers: Headers;
};

export type v1UpdateActionRunStatusResponse = (v1UpdateActionRunStatusResponseSuccess | v1UpdateActionRunStatusResponseError)

export const getV1UpdateActionRunStatusUrl = (ref: string,
    runId: string,) => {


  

  return `/v1/projects/${ref}/actions/${runId}/status`
}

export const v1UpdateActionRunStatus = async (ref: string,
    runId: string,
    updateRunStatusBody: UpdateRunStatusBody, options?: RequestInit): Promise<v1UpdateActionRunStatusResponse> => {
  
  return customFetch<v1UpdateActionRunStatusResponse>(getV1UpdateActionRunStatusUrl(ref,runId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateRunStatusBody,)
  }
);}
  

/**
 * Returns the logs from the specified action run.
 * @summary Get the logs of an action run
 */
export type v1GetActionRunLogsResponse200 = {
  data: string
  status: 200
}

export type v1GetActionRunLogsResponse401 = {
  data: void
  status: 401
}

export type v1GetActionRunLogsResponse403 = {
  data: void
  status: 403
}

export type v1GetActionRunLogsResponse429 = {
  data: void
  status: 429
}

export type v1GetActionRunLogsResponse500 = {
  data: void
  status: 500
}

export type v1GetActionRunLogsResponseSuccess = (v1GetActionRunLogsResponse200) & {
  headers: Headers;
};
export type v1GetActionRunLogsResponseError = (v1GetActionRunLogsResponse401 | v1GetActionRunLogsResponse403 | v1GetActionRunLogsResponse429 | v1GetActionRunLogsResponse500) & {
  headers: Headers;
};

export type v1GetActionRunLogsResponse = (v1GetActionRunLogsResponseSuccess | v1GetActionRunLogsResponseError)

export const getV1GetActionRunLogsUrl = (ref: string,
    runId: string,) => {


  

  return `/v1/projects/${ref}/actions/${runId}/logs`
}

export const v1GetActionRunLogs = async (ref: string,
    runId: string, options?: RequestInit): Promise<v1GetActionRunLogsResponse> => {
  
  return customFetch<v1GetActionRunLogsResponse>(getV1GetActionRunLogsUrl(ref,runId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Returns all database branches of the specified project.
 * @summary List all database branches
 */
export type v1ListAllBranchesResponse200 = {
  data: BranchResponse[]
  status: 200
}

export type v1ListAllBranchesResponse401 = {
  data: void
  status: 401
}

export type v1ListAllBranchesResponse403 = {
  data: void
  status: 403
}

export type v1ListAllBranchesResponse429 = {
  data: void
  status: 429
}

export type v1ListAllBranchesResponse500 = {
  data: void
  status: 500
}

export type v1ListAllBranchesResponseSuccess = (v1ListAllBranchesResponse200) & {
  headers: Headers;
};
export type v1ListAllBranchesResponseError = (v1ListAllBranchesResponse401 | v1ListAllBranchesResponse403 | v1ListAllBranchesResponse429 | v1ListAllBranchesResponse500) & {
  headers: Headers;
};

export type v1ListAllBranchesResponse = (v1ListAllBranchesResponseSuccess | v1ListAllBranchesResponseError)

export const getV1ListAllBranchesUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/branches`
}

export const v1ListAllBranches = async (ref: string, options?: RequestInit): Promise<v1ListAllBranchesResponse> => {
  
  return customFetch<v1ListAllBranchesResponse>(getV1ListAllBranchesUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Creates a database branch from the specified project.
 * @summary Create a database branch
 */
export type v1CreateABranchResponse201 = {
  data: BranchResponse
  status: 201
}

export type v1CreateABranchResponse401 = {
  data: void
  status: 401
}

export type v1CreateABranchResponse403 = {
  data: void
  status: 403
}

export type v1CreateABranchResponse429 = {
  data: void
  status: 429
}

export type v1CreateABranchResponse500 = {
  data: void
  status: 500
}

export type v1CreateABranchResponseSuccess = (v1CreateABranchResponse201) & {
  headers: Headers;
};
export type v1CreateABranchResponseError = (v1CreateABranchResponse401 | v1CreateABranchResponse403 | v1CreateABranchResponse429 | v1CreateABranchResponse500) & {
  headers: Headers;
};

export type v1CreateABranchResponse = (v1CreateABranchResponseSuccess | v1CreateABranchResponseError)

export const getV1CreateABranchUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/branches`
}

export const v1CreateABranch = async (ref: string,
    createBranchBody: CreateBranchBody, options?: RequestInit): Promise<v1CreateABranchResponse> => {
  
  return customFetch<v1CreateABranchResponse>(getV1CreateABranchUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createBranchBody,)
  }
);}
  

/**
 * Disables preview branching for the specified project
 * @summary Disables preview branching
 */
export type v1DisablePreviewBranchingResponse200 = {
  data: void
  status: 200
}

export type v1DisablePreviewBranchingResponse401 = {
  data: void
  status: 401
}

export type v1DisablePreviewBranchingResponse403 = {
  data: void
  status: 403
}

export type v1DisablePreviewBranchingResponse429 = {
  data: void
  status: 429
}

export type v1DisablePreviewBranchingResponse500 = {
  data: void
  status: 500
}

export type v1DisablePreviewBranchingResponseSuccess = (v1DisablePreviewBranchingResponse200) & {
  headers: Headers;
};
export type v1DisablePreviewBranchingResponseError = (v1DisablePreviewBranchingResponse401 | v1DisablePreviewBranchingResponse403 | v1DisablePreviewBranchingResponse429 | v1DisablePreviewBranchingResponse500) & {
  headers: Headers;
};

export type v1DisablePreviewBranchingResponse = (v1DisablePreviewBranchingResponseSuccess | v1DisablePreviewBranchingResponseError)

export const getV1DisablePreviewBranchingUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/branches`
}

export const v1DisablePreviewBranching = async (ref: string, options?: RequestInit): Promise<v1DisablePreviewBranchingResponse> => {
  
  return customFetch<v1DisablePreviewBranchingResponse>(getV1DisablePreviewBranchingUrl(ref),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Fetches the specified database branch by its name.
 * @summary Get a database branch
 */
export type v1GetABranchResponse200 = {
  data: BranchResponse
  status: 200
}

export type v1GetABranchResponse401 = {
  data: void
  status: 401
}

export type v1GetABranchResponse403 = {
  data: void
  status: 403
}

export type v1GetABranchResponse429 = {
  data: void
  status: 429
}

export type v1GetABranchResponse500 = {
  data: void
  status: 500
}

export type v1GetABranchResponseSuccess = (v1GetABranchResponse200) & {
  headers: Headers;
};
export type v1GetABranchResponseError = (v1GetABranchResponse401 | v1GetABranchResponse403 | v1GetABranchResponse429 | v1GetABranchResponse500) & {
  headers: Headers;
};

export type v1GetABranchResponse = (v1GetABranchResponseSuccess | v1GetABranchResponseError)

export const getV1GetABranchUrl = (ref: string,
    name: string,) => {


  

  return `/v1/projects/${ref}/branches/${name}`
}

export const v1GetABranch = async (ref: string,
    name: string, options?: RequestInit): Promise<v1GetABranchResponse> => {
  
  return customFetch<v1GetABranchResponse>(getV1GetABranchUrl(ref,name),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

